import blog_posts from 'public/assets/icons/resource-center/blog_posts.svg'
import developerDocs from 'public/assets/icons/resource-center/developer-docs.svg'
import integrations from 'public/assets/icons/resource-center/integrations.svg'
import partners from 'public/assets/icons/resource-center/partners.svg'
import plugins from 'public/assets/icons/resource-center/plugins.svg'
import providers from 'public/assets/icons/resource-center/providers.svg'
import starters from 'public/assets/icons/resource-center/starters.svg'
import tutorials from 'public/assets/icons/resource-center/tutorials.svg'
import userDocs from 'public/assets/icons/resource-center/user-docs.svg'

export const ResourceCenterIcons = Object.freeze({
  blog_posts: blog_posts,
  'developer-docs': developerDocs,
  integrations: integrations,
  partners: partners,
  plugins: plugins,
  providers: providers,
  starters: starters,
  tutorials: tutorials,
  'user-docs': userDocs,
})
